export default __webpack_public_path__ + "static/media/small-download-icon.f35cec19.svg";